import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, Form, Input, InputNumber, Row } from 'antd';
import { Add_SubPeriod_Api } from '../../API/SubPeriodApi';
import { AllCategoryComponent } from '../Category/AllCategoryComponent';
import { RollbackOutlined, CheckOutlined } from '@ant-design/icons';

// -----------------------------------------------------------
// وارد کردن DatePicker و تنظیمات شمسی (جایگزین antd-jalali)
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// -----------------------------------------------------------


// =================================================================
const SERVER_DATE_FORMAT = "YYYY-MM-DD"; 

/**
 * تابع کمکی برای تبدیل ارقام فارسی/عربی به انگلیسی و تبدیل اسلش به خط تیره.
 */
const persianToEnglishNumbers = (str) => {
    if (!str) return '';
    let output = String(str).trim(); 

    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
        output = output.replace(arabicNumbers[i], englishNumbers[i]);
    }

    return output.replace(/\//g, "-"); 
};

// =================================================================
/**
 * آداپتور سفارشی برای اتصال react-multi-date-picker به Form.Item آنت‌دیزاین.
 * خروجی همیشه YYYY-MM-DD با ارقام انگلیسی است.
 * توجه: در این کامپوننت، از آنجایی که ما خروجی را مستقیماً در State ذخیره می‌کنیم (setFromDate/setToDate)،
 * از ویژگی های داخلی Form.Item استفاده نمی‌کنیم، اما همچنان از آداپتور برای اطمینان از فرمت صحیح استفاده می‌شود.
 */
const PersianDatePickerAdapter = ({ value, onChange }) => {
    const [dateValue, setDateValue] = useState(null);

    const toDateObject = (dateString) => {
        if (!dateString) return null;
        const englishDateString = persianToEnglishNumbers(dateString); 
        
        return new DateObject({
            calendar: persian,
            locale: persian_fa,
            date: englishDateString,
            format: SERVER_DATE_FORMAT 
        });
    };
    
    useEffect(() => {
        // تنظیم مقدار اولیه (اگر از بیرون تنظیم شده باشد)
        setDateValue(toDateObject(value));
    }, [value]);

    const handleOnChange = (dateObject) => {
        setDateValue(dateObject); 

        let dateString = null;
        if (dateObject) {
            const persianDateString = Array.isArray(dateObject) ? 
                         dateObject.map(d => d.format(SERVER_DATE_FORMAT)) : 
                         dateObject.format(SERVER_DATE_FORMAT);
            // تبدیل ارقام فارسی به انگلیسی و اسلش به خط تیره در لحظه خروج
            dateString = persianToEnglishNumbers(persianDateString);
        }
        
        // ارسال مقدار رشته‌ای تمیز و انگلیسی (با خط تیره)
        onChange(dateString);
    };

    return (
        <DatePicker
            calendar={persian}
            locale={persian_fa}
            value={dateValue}
            onChange={handleOnChange}
            inputClass="ant-input persian-date-input" 
            calendarPosition="bottom-right"
            format={SERVER_DATE_FORMAT} 
        />
    );
};
// =================================================================

export const AddSubPeriodComponent = ({ periodId, periodCategoryId, setLoading, showMessage, rowInserted, cancelInsert }) => {
    // =================================================================
    const [form] = Form.useForm();
    // این State ها اکنون مستقیماً مقدار رشته‌ای YYYY-MM-DD را از آداپتور دریافت می‌کنند
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [categoryId, setCategoryId] = useState(-1);
    // =================================================================
    useEffect(() => {
        form.setFieldsValue({ isActive: true });
    }, []);
    // =================================================================
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            const finalValues = {
                ...values,
                id: 0,
                periodId: periodId,
                // استفاده از مقادیر State که از آداپتور دریافت شده‌اند
                from_Shamsi: fromDate,
                to_Shamsi: toDate,
                categoryId: categoryId,
            };

            let data = await Add_SubPeriod_Api(finalValues);
            rowInserted();
            setLoading(false);

            if (data.messageStatus === "Successful")
                showMessage(data.message, "Successful")
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        // !!! رفع مشکل رندر آبجکت خطا: تبدیل آبجکت خطا به رشته
        const errorFields = errorInfo.errorFields;
        let errorMessage = "خطا در تکمیل فرم. فیلدهای زیر مشکل دارند: \n";
        
        if (errorFields && errorFields.length > 0) {
            errorFields.forEach(field => {
                const fieldName = field.name.join(' '); 
                const fieldErrors = field.errors.join(' | '); 
                errorMessage += `\n ${fieldName}: ${fieldErrors}`;
            });
        } else {
             errorMessage = "خطا در تکمیل فرم: " + JSON.stringify(errorInfo);
        }

        showMessage(errorMessage, "error");
    };
    // =================================================================
    return (
        <>
            <div className='sectionTitle'>
                <h2 >
                    ایجاد زیردوره جدید
                </h2>
            </div>

            <div className='container'>
                <Form
                    name="basic"
                    form={form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                    onFinish={onSubmit}
                    onFinishFailed={onFinishFailed}
                >

                    <Form.Item
                        name="title"
                        label="عنوان"
                        rules={[{ required: true, message: 'لطفاً عنوان را وارد کنید!' }]}
                    >
                        <Input placeholder='عنوان' />
                    </Form.Item>

                    <Form.Item
                        name="comment"
                        label="شرح"
                    >
                        <Input placeholder='شرح' />
                    </Form.Item>

                    {/* کامپوننت انتخاب دسته */}
                    <Form.Item
                        label="دسته"
                        // نام فیلد (name) حذف شد تا تداخلی با State ایجاد نشود
                    >
                        <AllCategoryComponent
                            setLoading={setLoading}
                            showMessage={showMessage}
                            parentId={periodCategoryId}
                            isShowAddSubCategory={false}
                            isShowEdit={false}
                            isShowDelete={false}
                            isLoadObjectInstanceCategories={false}
                            isLoadCategoryFromParam={true}
                            selectedCategory={categoryId}
                            isShowCheckBox={true}
                            onCheckChange={(catId, checked) => { if (checked) setCategoryId(catId); }}
                        />
                    </Form.Item>


                    {/* جایگزین DatePickerJalali با PersianDatePickerAdapter */}
                    <Form.Item
                        // نام فیلد همچنان from_Shamsi است
                        name="from_Shamsi" 
                        label="از تاریخ"
                        rules={[{ required: true, message: 'لطفاً تاریخ شروع را انتخاب کنید!' }]}
                    >
                        {/* مقدار onChange این آداپتور، مقدار نهایی را به صورت YYYY-MM-DD انگلیسی برمی‌گرداند.
                          آن را مستقیماً در State ذخیره می‌کنیم.
                        */}
                        <PersianDatePickerAdapter onChange={(dateString) => { setFromDate(dateString); }} />
                    </Form.Item>

                    <Form.Item
                        name="to_Shamsi"
                        label="تا تاریخ"
                        rules={[{ required: true, message: 'لطفاً تاریخ پایان را انتخاب کنید!' }]}
                    >
                        <PersianDatePickerAdapter onChange={(dateString) => { setToDate(dateString); }} />
                    </Form.Item>

                    <Form.Item
                        name="orderIndex"
                        label="ترتیب"
                    >
                        <InputNumber />
                    </Form.Item>

                    <Form.Item
                        name="isActive"
                        valuePropName='checked'
                        label="فعال"
                    >
                        <Checkbox />
                    </Form.Item>
                </Form>
            </div>

            <Row className='sectionFooter'>
                <Col xs={0} sm={0} md={8} lg={16} xl={16} />
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        style={{ width: '98%' }}
                        className='btn-primary'
                        htmlType="submit"
                        onClick={() => form.submit()}>
                        <CheckOutlined />
                        ذخیره
                    </Button>
                </Col>
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        className='btn-secondary'
                        style={{ width: '100%' }}
                        onClick={() => cancelInsert()}>
                        <RollbackOutlined />
                        لغو </Button>
                </Col>
            </Row>
        </>
    )
}